"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoloDesktopDropdownMenu = void 0;
const react_1 = __importDefault(require("react"));
const DropdownSummary_1 = require("./DropdownSummary");
const Menu_styles_1 = require("./Menu.styles");
const shared_1 = require("../../shared");
const SoloDesktopDropdownMenu = ({ summaryNode, menuId }) => {
    const { open: menuOpen, setActiveMenu } = (0, shared_1.useMyActiveMenu)(menuId);
    const openMenu = (0, shared_1.useOpenMenu)(menuId);
    const closeMenu = (0, shared_1.useCloseMenu)();
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setActiveMenu, menuId);
    let node = summaryNode;
    if (react_1.default.isValidElement(summaryNode)) {
        node = react_1.default.cloneElement(summaryNode, Object.assign({}, {
            role: 'menuitem'
        }));
    }
    return (react_1.default.createElement(Menu_styles_1.Menu, { role: "menu", static: true, onMouseEnter: openMenu, onMouseLeave: closeMenu },
        react_1.default.createElement(DropdownSummary_1.DropdownSummary, { menuId: menuId, openMenu: openMenu, onKeyUp: toggleMenu, disableTriangles: true }, node)));
};
exports.SoloDesktopDropdownMenu = SoloDesktopDropdownMenu;
//# sourceMappingURL=SoloDesktopDropdownMenu.js.map